import Services = require("../services/services");
import Base = require("./base/geoquery");
import Utils = require("../utils");

/**
 * Introduces self-documenting about, input, output in the event
 * we create a web-based CE that can interegate the underlying API
 *
 * The input/output should be enforced via interfaces for programmatic usage
 * but commands are not used that way so it's too much work considering
 * the amount of flux in the code and the payoff (none).
 */
class Command extends Base<any> {

    static about = `
Executes an Infor Public Sector REST service.

Usage Example:

    See app/test/commands/multiplexer for a complex example of querying property/parcels to validate the existing of a parcel.

Experimental Usage Example (Formula):

      <EVENT about="Invokes arbitrary REST service but in this case it is a formula to decide if this is a valid parcel" event="civics:show-details" id="formula-validator" mid="app/commands/ips-query">
        <OPTIONS>
          <Values about="once the validation result is available notify the validator" id="event" value="formula-validation" />
          <Values about="REST endpoint" id="query-service" value="portal/scenario/map/location/validation" />
          <Values id="service-query-template" value="{&#xD;&#xA;    &quot;formulaName&quot;: &quot;FalseMapValidation&quot;,&#xD;&#xA;    &quot;Data&quot;: {&#xD;&#xA;        &quot;attributes&quot;: {&#xD;&#xA;            &quot;PARCLKEY&quot;: 10153454,&#xD;&#xA;            &quot;PARCLID&quot;: &quot;00005-44454-4546&quot;&#xD;&#xA;        }&#xD;&#xA;    }&#xD;&#xA;}" />
          <Values about="What populates the query template. - in this case the template &quot;Data&quot; is the activeFeature" id="data" value="activeFeature" />
        </OPTIONS>
      </EVENT>

The _service-query-template_ value when unescaped looks like this and would be used to invoke the FalseMapValidation formula made available
on _portal/scenario/map/location/validation_:

    {
        "formulaName": "FalseMapValidation",
        "Data": {
            "attributes": {
                "PARCLKEY": 10153454,
                "PARCLID": "00005-44454-4546"
            }
        }
    }

    `;

    static options = Utils.defaults({
        "data": {
            "about": "the name of the attribute to pass to the query template"
        },
        "query-service": {
            "about": "the REST endpoint",
        },
        "service-query-template": {
            "about": "the query template",
        },
    }, Base.options);

    static output = {
        "request": "the query that was sent to the endpoint",
        "response": "the response from the service"
    };

    /**
     * creates a REST query, executes it, published the response 
     */
    execute(args = this.args) {
        let queryService = this.findOption("query-service");
        let template = this.findOption("service-query-template");

        let query = {};
        {
            let dataName = this.findOption("data");
            if (dataName) {
                query = this.findArg(dataName, this.args)[dataName] || query;
            }
        }
        query = template ? _.template(template)(query) : query;

        let service = new Services.BaseService({
            query: query
        }, queryService);

        // post or each?        
        service.each().done(response => {
            this.trigger({
                "request": query,
                "response": response
            });
        });

    }
}

export = Command;